import "./SearchBox.scss";
import { TextField, Autocomplete, Box, CircularProgress } from "@mui/material";
import { Search } from "@mui/icons-material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
type Props = {
  value?: string | null;
  onChange?: any;
  label?: string;
  placeholder?: string;
  onRequest?: any;
  style?: any;
  onCancel?: any;
  dropdownList?: any;
  optionLabel?: any;
  logo?: any;
  renderOption?: any;
  sx?: any;
  no_option?: any;
  onTextChange?: any;
  className?: any;
};

export const SearchBoxWithDropdown = (props: Props) => {
  return (
    <Autocomplete
      className={`SearchBoxDropdown ${props.className ? props.className : ""}`}
      options={props.dropdownList}
      getOptionLabel={props.optionLabel}
      autoHighlight
      onChange={(e: any, val: any) => props.onChange(e, val)}
      value={props.value ? props.value : null}
      renderOption={props.renderOption}
      noOptionsText={
        props.dropdownList.length !== 0 ? (
          props.no_option
        ) : (
          <Box textAlign={"center"}>
            <CircularProgress sx={{ color: "var(--primary_color)" }} />
          </Box>
        )
      }
      popupIcon={
        <Search
          sx={{ color: "var(--primary_color)" }}
          height="16px"
          width="16px"
        />
      }
      sx={{
        width: "100%",
        "& .MuiAutocomplete-popupIndicator": { transform: "none" },
      }}
      renderInput={(params: any) => {
        return (
          <TextField
            className="SearchBoxTextField"
            placeholder={props.placeholder}
            onChange={(e: any) => props.onTextChange(e)}
            variant="filled"
            sx={props.sx}
            {...params}
          />
        );
      }}
    />
  );
};
